import { useRef, useEffect } from "react";
import { select, axisLeft, axisRight } from "d3";

import "./YAxis.css";

export const YAxis = ({
  yScale,
  innerWidth,
  rightAxis = false,
  margin = 0,
  ticks = 10,
}) => {
  const ref = useRef();
  useEffect(() => {
    const yAxisG = select(ref.current);
    let yAxis = axisLeft(yScale).tickPadding(1).ticks(ticks);
    if (rightAxis) {
      yAxis = axisRight(yScale).tickPadding(1);
    }
    yAxisG.call(yAxis);
  }, [yScale, innerWidth]);

  let transformValue = `translate(${margin}, 0)`;
  if (rightAxis) {
    transformValue = `translate(${innerWidth}, 0)`;
  }
  return (
    <g
      ref={ref}
      transform={transformValue}
      className={rightAxis ? "yaxisRight" : "yaxisLeft"}
    />
  );
};
